import { useCallback, useState } from "react";
import {
    ChartOfAccountsTemplatesView,
    ChartOfAccountsTemplatesViewSchema,
} from "@common/types/views/chartOfAccountsTemplatesView";
import { View } from "@common/types/views/views";
import {
    WORKSPACE_USER_CACHE_KEYS,
    useWorkspaceUserCache,
} from "@hooks/useWorkspaceUserCache";
import { chartOfAccountsTemplatesViewConfig } from "./chartOfAccountsTemplatesViewConfig";
import { defaultChartOfAccountsTemplatesView } from "./chartOfAccountsTemplatesView";

export function useChartOfAccountsTemplatesView() {
    const [cachedView, setCachedView] =
        useWorkspaceUserCache<ChartOfAccountsTemplatesView>(
            WORKSPACE_USER_CACHE_KEYS.CHART_OF_ACCOUNTS_TEMPLATES_PAGE_VIEW_CACHE_KEY,
            ChartOfAccountsTemplatesViewSchema,
        );
    const [view, setView] = useState<ChartOfAccountsTemplatesView>(
        cachedView ?? defaultChartOfAccountsTemplatesView,
    );

    const handleViewChange = useCallback(
        (newView: View) => {
            const parsed =
                ChartOfAccountsTemplatesViewSchema.safeParse(newView);
            if (!parsed.success) {
                return;
            }
            setView(parsed.data);
            setCachedView(parsed.data);
        },
        [setCachedView],
    );

    return {
        view,
        defaultView: defaultChartOfAccountsTemplatesView,
        viewConfig: chartOfAccountsTemplatesViewConfig,
        handleViewChange,
    };
}
